import posthog from 'posthog-js';

const KEY = process.env.REACT_APP_POSTHOG_KEY;

if (KEY) {
  posthog.init(KEY, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false,   // manual — we track view changes ourselves
    capture_pageleave: true,
    autocapture: true,
    persistence: 'localStorage',
  });
}

/** Fire a custom event. No-ops when REACT_APP_POSTHOG_KEY is not set. */
export function capture(event, props = {}) {
  if (!KEY) return;
  posthog.capture(event, props);
}

/** Record an exception without putting customer data into the event payload. */
export function captureError(error, context = {}) {
  if (!KEY) return;
  if (typeof posthog.captureException === 'function') {
    posthog.captureException(error, context);
    return;
  }
  posthog.capture('application_error', {
    message: error?.message || String(error),
    name: error?.name || 'Error',
    ...context,
  });
}

/** Tie all future events to a known user. Call after login/signup. */
export function identify(userId, traits = {}) {
  if (!KEY) return;
  posthog.identify(userId, traits);
}

/** Unlink the user on sign-out so subsequent events go to a new anonymous ID. */
export function phReset() {
  if (!KEY) return;
  posthog.reset();
}

export default posthog;
